import { FormObjType } from "DataTypes/Form";

export const AddEditForm: FormObjType[] = [
  {
    id: "problem-name",
    label: "Problem Name",
    placeholder: "Select Problem Name",
    boxType: "single-select",
    boxSize: 4,
    validatetype: "dropdown",
    required: true,
    enableFormLoad: true,
    iconSearch: true
  },
  {
    id: "icd-code",
    label: "ICD Codes",
    placeholder: "Select ICD Codes",
    boxType: "multi-select",
    boxSize: 4,
    validatetype: "multi-dropdown",
    required: true,
    enableFormLoad: true,
    iconSearch: true
  },
  {
    id: "date-start-date",
    label: "Start Date",
    placeholder: "Select Start Date",
    boxType: "date-time",
    boxSize: 4,
    validatetype: "date",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "date-end-date",
    label: "End Date",
    placeholder: "Select End Date",
    boxType: "date-time",
    boxSize: 4,
    validatetype: "date",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "input-comments",
    label: "Comments",
    placeholder: "Enter Comments",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
]